module.exports = __webpack_public_path__ + "static/media/brand_amex.7979948b.svg";